import * as React from "react";
import { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useGetPopulateLeadQuery } from "../reducers/facilityapi";
import { SHOWLEADEVENT } from "../constants/event";
import { RootState } from "../reducers/index";
import { useAppSelector } from "../store/index";
import { IInitOptions } from "../interfaces/initoptions";
import LeadArea from "./leadarea";
//import { useGetMeetingsQuery } from "../reducers/providerapi";

const OffcanvasForm = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { facilityId, facilityName, facilityImageUrl } = useAppSelector<
        IInitOptions
    >((state: RootState) => state.initOptions);
    const { data, isSuccess } = useGetPopulateLeadQuery({
        facilityId: facilityId,
    }, {});

    // get the lead form data
    let formEl: JSX.Element;
    if (isSuccess) {
        formEl = <LeadArea populateLead={data} onHide={handleClose} />;
    } else {
        formEl = (
            <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        );
    }

    // monitor external button clicking
    useEffect(() => {
        window.addEventListener(
            SHOWLEADEVENT,
            handleShow,
            false,
        );
        return () => {
            window.removeEventListener(SHOWLEADEVENT, handleShow);
        };
    }, []);

    return (
        <Offcanvas
            show={show}
            onHide={handleClose}
            placement={"end"}
            className="facility-lead"
        >
            <Offcanvas.Header
                closeButton
                className="offcanvas-header border-bottom"
            >
                <Offcanvas.Title as="div">
                    <div className="facility-lead-header">
                        <div className="header-img">
                            <img
                                src={facilityImageUrl}
                                className="img-fluid rounded"
                            />
                        </div>
                        <div className="header-text">
                            <h5>Contact {facilityName}</h5>
                        </div>
                    </div>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="facility-lead-body">
                {formEl}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

// event stuff
// https://stackoverflow.com/questions/63698105/communicating-with-a-functional-component-outside-of-react

export default OffcanvasForm;
